export const carouselBreakpoints = {
  sm: {
    slidesPerView: 3,
    slidesPerGroup: 3,
  },
  md: {
    slidesPerView: 3,
    slidesPerGroup: 3,
  },
  lg: {
    slidesPerView: 4,
    slidesPerGroup: 4,
  },
  xl: {
    slidesPerView: 6,
    slidesPerGroup: 6,
  },
};
